import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../interface_user/header/header";
import Footer from "../interface_user/footer/footer";
import Footer1 from "../interface_user/footer/footer1";
import axios from "axios";
import { jwtDecode } from 'jwt-decode'; // Importation corrigée
import { CheckOutlined, ClockCircleOutlined } from "@ant-design/icons";

import { baseApiUrl } from "../../services/api";
import { Table, Modal, Button, notification, Input, Switch } from "antd";
import UserDashboard from "./dashbaoruser";


function DetailProfile() {
  const [utilisateur, setUtilisateur] = useState(null);
     const [titre, setTitre] = useState("");
      const [description, setDescription] = useState("");
      const [categoriesOptions, setCategoriesOptions] = useState([]);
        const [projets, setProjets] = useState([]);
        const [publications, setPublications] = useState([]);

      const [document, setDocument] = useState(null);
        const [image, setImage] = useState("");

      const [zoneExecution, setZoneExecution] = useState(null);

      const [impactEconomique, setImpactEconomique] = useState(null);

      const [impactSocial, setImpactSocial] = useState(null);

      const [impactEnvironnemental, setImpactEnvironnemental] = useState(null);

      const [selectedCategorie, setSelectedCategorie] = useState(null);

      const [video, setVideo] = useState("");


      const [calendrierFin, setCalendrierFin] = useState("");
      const [calendrierDebut, setCalendrierDebut] = useState("");

      const [step, setStep] = useState(1);

      const [isAddModalVisible, setIsAddModalVisible] = useState(false);
      const [editModalVisible, setEditModalVisible] = useState(false);
      const [isEditModalVisible, setIsEditModalVisible] = useState(false);
      const [isViewModalVisible, setIsViewModalVisible] = useState(false);
      const [isEditMode, setIsEditMode] = useState(false);
      const [editingProjet, setEditingProjet] = useState(null);
      const [viewingProjet, setViewingProjet] = useState(null);

  const { profileId } = useParams();
    const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur


     // Récupérer les publications de l'utilisateur connecté
  const fetchPublications = async () => {
    if (!currentUser?.id) {
      console.warn("Utilisateur connecté introuvable, impossible de filtrer les publications.");
      return;
    }

    try {
      const response = await baseApiUrl.get("/publication/liste");
      console.log("Données reçues des publications :", response.data);

      const allPublications = Array.isArray(response.data) ? response.data : [];

      // Filtrer les publications en fonction de l'utilisateur connecté
      const userPublications = allPublications.filter(
        (pub) => pub.utilisateur?.id === currentUser.id
            );

      setPublications(userPublications);
      console.log("Publications de l'utilisateur connecté :", userPublications);
    } catch (error) {
      console.error("Erreur lors de la récupération des publications de l'utilisateur :", error);
    }
  };

   const openNotificationWithIcon = (type, message) => {
      notification[type]({
        message: message,
      });
    };



  const handleEdit = (projet) => {
    setViewingProjet(projet);
    setEditingProjet(projet);

    setTitre(projet.titre);
    setDescription(projet.description);
    setZoneExecution(projet.zoneExecution);
    setImpactEconomique(projet.impactEconomique);
    setImpactSocial(projet.impactSocial);
    setImpactEnvironnemental(projet.impactEnvironnemental);
    setSelectedCategorie(projet.categorieId);
    setImage(projet.image);
    setDocument(projet.document);
    setCalendrierDebut(projet.calendrierDebut);
    setCalendrierFin(projet.calendrierFin);
    setIsEditMode(true);
    setIsEditModalVisible(true);


    setSelectedCategorie(projet.categorieId); // Assurez-vous de définir la catégorie sélectionnée correctement
    setIsEditModalVisible(true);
  };




   useEffect(() => {
      const token = localStorage.getItem('token'); // Assurez-vous que c'est le bon nom de clé
      if (token) {
        try {
          const decoded = jwtDecode(token); // Utilisation de jwtDecode
          setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
          console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur

          // Si vous voulez directement récupérer le nom
      if (decoded.nom) {
          console.log("Nom de l'utilisateur:", decoded.nom);
        }
        } catch (error) {
          console.error("Erreur lors du décodage du token:", error);
        }
      } else {
        console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
      }

    }, []);

    const handleNext = () => {
      setStep(step + 1);
    };

    const handlePrevious = () => {
      setStep(step - 1);
    };

    const handleEditProjet = async (e) => {
         e.preventDefault();

         // Vérification si un projet est sélectionné pour la modification
         if (!editingProjet) {
           openNotificationWithIcon("error", "Aucun projet sélectionné pour la modification.");
           return;
         }

         // Vérification que tous les champs nécessaires sont remplis
         if (!titre) {
           openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
           return;
         }

         // Préparation des données du projet
         const projetData = {
          titre,
          description,
          categorieId: selectedCategorie,
          zoneExecution,
          impactEconomique,
          impactEnvironnemental,
          impactSocial,

         };

         // Création de FormData pour les requêtes multipart/form-data
         const formData = new FormData();
         formData.append("publication", new Blob([JSON.stringify(projetData)], { type: "application/json" }));


         if (image) formData.append("image", image); // Ajout de l'image si elle existe
         if (document) formData.append("document", document); // Ajout du document si nécessaire

         formData.forEach((value, key) => {
           console.log(`${key} :`, value);
         });

         try {
           // Envoi de la requête pour modifier le projet
           const response = await baseApiUrl.put(`/publication/update/${editingProjet.id}`, formData, {
             headers: {
               "Content-Type": "multipart/form-data",
             },
           });

           if (response.status !== 200) {
             throw new Error(`Erreur HTTP: ${response.status}`);
           }

           // Mise à jour de la liste des projets
           const updatedProjet = await response.data;
           console.log("Projet mis à jour:", updatedProjet);

           setProjets(
             projets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet))
           );

           openNotificationWithIcon("success", "Publication modifié avec succès.");
           fetchPublications();
         } catch (error) {
           console.error("Erreur lors de la modification du projet:", error);
           openNotificationWithIcon("error", "Erreur lors de la modification du projet.");
         }

         // Réinitialisation du formulaire après l'envoi
         resetForm();
       };


    const truncateText = (text, wordLimit) => {
      if (typeof text !== "undefined" && text !== null) {
        const words = text.split(" ");
        if (words.length > wordLimit) {
          return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
        }
        return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
      } else {
        return ""; // Retourne une chaîne vide si text est undefined ou null
      }
    };

    const resetForm = () => {
      setStep(1);
      setIsEditMode(false);
      setEditingProjet(null);
      setIsAddModalVisible(false);
      setIsEditModalVisible(false);
      setIsViewModalVisible(false);
      setTitre("");


      setDescription("");

      setSelectedCategorie("");
      setImage("");
      setDocument("");

      setZoneExecution("");
      setImpactEconomique("");
      setImpactEnvironnemental("");
      setImpactSocial("")


      setIsEditMode(false);
      setEditingProjet(null);
      setIsAddModalVisible(false);
      setIsEditModalVisible(false);
      setIsViewModalVisible(false);
    };


    const handleView = (projet) => {
      setViewingProjet(projet);
      setIsViewModalVisible(true);
    };

  useEffect(() => {
    if (profileId) {
      baseApiUrl
        .get(`/utilisateur/${profileId}`)
        .then((response) => {
          setUtilisateur(response.data);
          console.log("Utilisateur récupéré :", response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération de l'utilisateur :", error);
        });
    } else {
      console.error("L'ID du profil est introuvable !");
    }

    // Appeler la fonction fetchPublications après avoir défini currentUser
    if (currentUser) {
      fetchPublications();
    }
  }, [profileId, currentUser]);

  useEffect(() => {
    if (currentUser) {
      fetchPublications();
    }
  }, [currentUser]);

  // if (!utilisateur) return <p>Chargement des informations...</p>;
  return (
    <UserDashboard/>
//     <detail>
//       <Header />
//       <div
//         className="inner-hero bg-cover"
//         style={{
//           backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
//         }}
//       >
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="main-heading">

//                 <h1>Profile details</h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="blog-details1-all sp">
//         <div className="container">


//           <br /><br />

//           <div className="row">
//           <div class="col-lg-4">
// 						<div class="blog1-sidebar-area mt-40 ml-30 sm:ml-0 md:ml-0 md:mt-30 sm:mt-30">
// 							{/* <div class="sidebar-details-widget_1 _search-area1">
// 								<h3>Search</h3>
// 								<form action="#">
// 									<input type="text" placeholder="Search..." />
// 								</form>
// 							</div> */}
// 							<div class="sidebar-details-widget_1 _author-intro mt-40">
// 								<div class="sidebar-author-thumb text-center">
//                                 <img
//                     //   className="w-full"
//                     className="rounded-circle"
//                                width="100"
//                                height="100"
//                       // src={`http://localhost:8081/api/plateforme/image/${utilisateur.photo}`}
//                       alt="Project"

//                       src={
//                                             currentUser && currentUser.photo
//                                                 ? baseApiUrl.defaults.baseURL +`/image/${currentUser.photo}`
//                                                 : "https://via.placeholder.com/30"
//                                             }

//                     />
//                     	{/* <h4>{utilisateur.nom}-{utilisateur.prenom}</h4> */}
//                         <p className="mt-2">


//                              </p>
//                              <p class="mt-10 p-with-sapn"><span>{currentUser?.nom} {currentUser?.prenom}</span ></p>

//                              	<div class="heading1">
// 										{/* <p>Whether you’re a tech enthusiast or a business leader, these emerging trends are reshaping the future and offering endless opportunities for growth and creativity.</p> */}

// 									</div>

// 								</div>
// 							</div>



// 						</div>
// 					</div>
//             <div className="col-lg-8">
//             <h1 text-center>Mes publications</h1>

//               <div className="details content-area mt-40">

//                         <article>
// 								<div class="heading1 mt-40">
// 								<Table
//   rowKey="id"
//   columns={[
//     {
//       title: "Titre",
//       dataIndex: "titre",
//       key: "titre",
//       render: (text) => truncateText(text, 6), // Tronque le titre à 5 mots
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       render: (text) => truncateText(text, 6), // Tronque la description à 5 mots
//     },
//     {
//       title: "Statut",
//       dataIndex: "actif",
//       key: "actif",
//       render: (actif) =>
//         actif ? (
//           <span>
//             <CheckOutlined style={{ color: "green" }} /> Validé
//           </span>
//         ) : (
//           <span>
//             <ClockCircleOutlined style={{ color: "orange" }} /> En attente
//           </span>
//         ),
//     },
//     {
//       title: "Image",
//       dataIndex: "image",
//       key: "image",
//       render: (imageName) => {
//         // Définir le chemin complet de l'image
//         const imageUrl = baseApiUrl.defaults.baseURL + `/image/${imageName}`;
//         return (
//           <img
//             src={imageUrl}
//             alt="project"
//             style={{
//               width: "50px",
//               height: "50px",
//               borderRadius: "50%",
//               objectFit: "cover",
//             }}
//           />
//         );
//       },
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (text, record) => (
//         <div className="text-end">
//           {/* Bouton Voir (affiché dans tous les cas) */}
//           <Button
//             className="ms-2 btn btn-sm bg-success-light"
//             onClick={() => {
//               resetForm();
//               handleView(record);
//             }}
//           >
//             Voir
//           </Button>

//           {/* Boutons Modifier et Supprimer (affichés uniquement si en attente) */}
//           {!record.actif && (
//             <>
//               <Button
//                 className="ms-2 btn btn-sm bg-primary-light"
//                 onClick={() => {
//                   resetForm();
//                   handleEdit(record);
//                 }}
//               >
//                 Modifier
//               </Button>
//               <Button
//                 className="ms-2 btn btn-sm bg-danger-light"
//                 onClick={() => handleDeleteConfirm(record)}
//               >
//                 Supprimer
//               </Button>
//             </>
//           )}
//         </div>
//       ),
//     },
//   ]}
//   dataSource={publications}
// />


// 								</div>
// 							</article>




//               </div>
//             </div>




//           </div>

//             <Modal
//                       title="Modifier une publication"
//                       visible={isEditModalVisible}
//                       onCancel={() => setIsEditModalVisible(false)}
//                       width={800}
//                     >
//                       <form onSubmit={handleEditProjet}>
//                         {step === 1 && (
//                           <>
//                             <div className="row">
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Titre de la publication</label>
//                                   <input
//                                     type="text"
//                                     className="form-control"
//                                     value={titre}
//                                     onChange={(e) => setTitre(e.target.value)}
//                                   />
//                                 </div>
//                               </div>
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Zone d'exécution</label>
//                                   <textarea
//                                     type="text"
//                                     className="form-control"
//                                     value={zoneExecution}
//                                     onChange={(e) => setZoneExecution(e.target.value)}
//                                     style={{ width: "100%", height: "100px" }}
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="row">
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Impact économique</label>
//                                   <textarea
//                                     type="text"
//                                     className="form-control"
//                                     value={impactEconomique}
//                                     onChange={(e) => setImpactEconomique(e.target.value)}
//                                     style={{ width: "100%", height: "100px" }}
//                                   />
//                                 </div>
//                               </div>
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Description de la publication</label>
//                                   <textarea
//                                     type="text"
//                                     className="form-control"
//                                     value={description}
//                                     onChange={(e) =>
//                                       setDescription(e.target.value)
//                                     }
//                                     style={{ width: "100%", height: "100px" }}
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="row">
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Impact environnemental</label>
//                                   <textarea
//                                     type="text"
//                                     className="form-control"
//                                     value={impactEnvironnemental}
//                                     onChange={(e) => setImpactEnvironnemental(e.target.value)}
//                                     style={{ width: "100%", height: "100px" }}
//                                   />
//                                 </div>
//                               </div>
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Impact Social</label>
//                                   <textarea
//                                     type="text"
//                                     className="form-control"
//                                     value={impactSocial}
//                                     onChange={(e) => setImpactSocial(e.target.value)}
//                                     style={{ width: "100%", height: "100px" }}
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                             <button
//                               type="button"
//                               className="btn btn-primary"
//                               onClick={handleNext}
//                             >
//                               Suivant
//                             </button>
//                           </>
//                         )}

//                         {step === 2 && (
//                           <>


//                             <div className="row">
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Domaine de la publication</label>
//                                   <select
//                                     className="form-control"
//                                     value={selectedCategorie}
//                                     onChange={(e) => setSelectedCategorie(Number(e.target.value))}                        >
//                                     <option value="">Sélectionnez un domaine...</option>
//                                     {/* Valeur par défaut */}
//                                     {categoriesOptions.map((category) => (
//                                       <option key={category.value} value={category.value}>
//                                         {category.label}
//                                       </option>
//                                     ))}
//                                   </select>
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="row">
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Document du publication</label>
//                                   <input
//                                     type="file"
//                                     className="form-control"
//                                     onChange={(e) => setDocument(e.target.files[0])}
//                                   />
//                                 </div>
//                               </div>
//                               <div className="col-sm-6 col-12">
//                                 <div className="form-group">
//                                   <label>Image de la publication</label>
//                                   <input
//                                     type="file"
//                                     className="form-control"
//                                     onChange={(e) => setImage(e.target.files[0])}
//                                   />
//                                 </div>
//                               </div>
//                             </div>



//                             <button
//                               type="button"
//                               className="btn btn-secondary"
//                               onClick={handlePrevious}
//                             >
//                               Précédent
//                             </button>

//                             <button
//                               type="submit"
//                               className="btn btn-primary"

//                             >
//                               Créer
//                             </button>
//                           </>
//                         )}
//                       </form>
//                     </Modal>

//                     {/* Modal pour afficher les détails  */}

//             <Modal
//                       title="Information de la publication"
//                       visible={isViewModalVisible}
//                       onCancel={() => setIsViewModalVisible(false)}
//                       width={800}
//                     >
//                         {viewingProjet && (
//                       <div >
//                         {step === 1 && (
//                           <>

//                            <div>
//                           {/* <h4>{viewingProjet?.titre}</h4> */}
//                           <p>
//                             <strong>Titre de la publication:</strong> {viewingProjet?.titre}
//                           </p>
//                           <p>
//                             <strong>Zone d'exécution:</strong> {viewingProjet?.zoneExecution}
//                           </p>
//                           <p>
//                             <strong>Impact économique:</strong> {viewingProjet?.impactEconomique}
//                           </p>
//                           <p>
//                             <strong>Description de la publication:</strong> {viewingProjet?.description}
//                           </p>

//                         </div>


//                             <button
//                               type="button"
//                               className="btn btn-primary"
//                               onClick={handleNext}
//                             >
//                               Suivant
//                             </button>
//                           </>
//                         )}

//                         {step === 2 && (
//                           <>
//                              <div>
//                              <p>
//                             <strong>Impact environnemental:</strong> {viewingProjet?.impactEnvironnemental}
//                           </p>
//                           <p>
//                             <strong>Impact Social:</strong> {viewingProjet?.impactSocial}
//                           </p>
//                           <p>
//                             <strong>Domaine de la publication:</strong> {viewingProjet?.selectedCategorie}
//                           </p>

//                           <p>
//                             <strong>Date de creation:</strong> {viewingProjet?.created}
//                           </p>

//                         </div>

//                             <button
//                               type="button"
//                               className="btn btn-secondary"
//                               onClick={handlePrevious}
//                             >
//                               Précédent
//                             </button>
//                           </>
//                         )}
//                       </div>
//                         )}
//                     </Modal>
//         </div>
//       </div>



//       <Footer1 />

//       <Footer />
//     </detail>
  );
}

export default DetailProfile;
